export const membershipLevels = {
  activity: 'activity',
  phase: 'phase',
  project: 'project',
  board: 'board',
  team: 'team',
  scope: 'scope'
} as const;
